module.exports = __webpack_public_path__ + "static/media/a2.a6ef0039.jpg";